import {
  enum_,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import { TRUCK_MODEL_IMPORT_JOB_STATUS_TYPE } from '@/libs/api/types'

/**
 * 車種のインポート履歴の検索条件
 */
export const truckModelImportJobsSearchSchema = object({
  dcId: optional(number()),
  page: optional(number()),
  /** インポートステータス */
  status: optional(enum_(TRUCK_MODEL_IMPORT_JOB_STATUS_TYPE)),
  /** ファイル名 */
  fileName: optional(string())
})

export type TruckModelImportJobsSearch = InferOutput<
  typeof truckModelImportJobsSearchSchema
>
